// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width: 991px) {\n.rowNum__custom {\n    max-width: 13.99px !important;\n}\n}\n.amount-text {\n  color: #BD0F72;\n  font-weight: bold;\n}\n.label-display {\n  margin-bottom: 0;\n}\n.error-controls {\n  background: #F5DBDC;\n  border: 1px solid #FF0000;\n}", ""]);
// Exports
module.exports = exports;
